<template>
           <aside class="aside-menu">
        
       <b-tabs v-if="inheritance">
      <b-tab title="<i class='icon-speech'></i> Cronologia azioni">
        <div class="p-3">
            <div v-for="action in inheritance.actions">
                <div class="message" >
                    <div>
                        <small class="text-muted">{{action.user.firstName}} {{action.user.lastName}}</small>
                        <small class="text-muted float-right mt-1">{{action.date | formatFullDate}}</small>
                    </div>
                    <div>{{action.description}}</div>
                </div>
                <hr class="text-muted">

            </div>
        </div>
      </b-tab>
    
    </b-tabs>
    </aside>
</template>

<script>
import Callout from './Callout'
import cSwitch from './Switch'
export default {
  name: 'c-aside',
  components: {
    Callout,
    cSwitch
        },
        computed: {
            inheritance: function () {
                return this.$store.state.inheritance;
            }
        }
}
</script>
